import React from "react";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import "./Colours.css";

const Colours = (props) => {
  return (
    <Carousel
      className="carousel-root"
      showArrows={true}
      showThumbs={false}
      showStatus={false}
      infiniteLoop={true}
      useKeyboardArrows={true}
      emulateTouch={true}
      renderArrowPrev={(onClickHandler, hasPrev, label) =>
        hasPrev && (
          <button type="button" className="custom-arrow custom-prev" onClick={onClickHandler} aria-label={label}>
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z" fill="#505050" />
            </svg>
          </button>
        )
      }
      renderArrowNext={(onClickHandler, hasNext, label) =>
        hasNext && (
          <button type="button" className="custom-arrow custom-next" onClick={onClickHandler} aria-label={label}>
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6z" fill="#505050" />
            </svg>
          </button>
        )
      }
    >
      <div className="colour-slide">
        <img src="../assets/image/color/colorImage1.jpg" alt="Color Set 1" />
        <p className="legend"> Color Set 1 </p>
      </div>
      <div className="colour-slide">
        <img src="../assets/image/color/colorImage2.jpg" alt="Color Set 2" />
        <p className="legend"> Color Set 2 </p>
      </div>
      <div className="colour-slide">
        <img src="../assets/image/color/colorImage3.jpg" alt="Color Set 3" />
        <p className="legend"> Color Set 3 </p>
      </div>
    </Carousel>
  );
};

export default Colours;
